import { jsHooks } from "@swo/shared";
import { css } from "@emotion/react";
import { SmallLoadingSpinner } from "../../../../routes/modal-loading-spinner";
import { SwarovskiButton } from "../../../../components/_shared-components/ui-elements/SwarovskiButton";
import React from "react";
import { useCartContext } from "../../../../global/cart-context/cart-context";
import cn from "classnames";
import { PDPButtonWithAction } from "../availability/types";
import { T } from "../../../../components/T";

export type PDPStickyDesktopButtonSize = "tiny" | "small" | "normal";

const variant = "green";

export function getPdpStickyDesktopButton(btn: PDPButtonWithAction, isManipulatingCart: boolean) {
  const className = jsHooks.pdpBar(true);

  const { cart } = useCartContext();

  const hasAnyCartAction =
    isManipulatingCart || (cart._tag === "Right" && cart.right.updatingKey === "add-items-to-cart");

  const { tag } = btn;

  const children = (
    <span
      css={css`
        display: flex;
        align-items: center;
        white-space: nowrap;
        justify-content: center;
      `}
    >
      <span>
        <T>{btn.label}</T>
      </span>{" "}
      <SmallLoadingSpinner
        color={"white"}
        className={cn({ visible: hasAnyCartAction })}
        css={css`
          position: absolute;
          right: 12px;
          top: calc(50% - 5px);

          visibility: hidden;
          &.visible {
            visibility: visible;
          }
        `}
      />
    </span>
  );

  if (tag === "action") {
    return (size: PDPStickyDesktopButtonSize) => (
      <SwarovskiButton
        variant={variant}
        as={"button"}
        disabled={false}
        onClick={
          hasAnyCartAction
            ? undefined
            : () => {
                void btn.f();
              }
        }
        className={className}
        size={size}
      >
        {children}
      </SwarovskiButton>
    );
  } else if (tag === "internal-link") {
    return (size: PDPStickyDesktopButtonSize) => (
      <SwarovskiButton
        className={className}
        variant={variant}
        as={"a"}
        disabled={false}
        link={btn.href}
        isInternal={true}
        scrollToTop={true}
        onClick={btn.onClick}
        size={size}
      >
        {children}
      </SwarovskiButton>
    );
  } else {
    return (size: PDPStickyDesktopButtonSize) => (
      <SwarovskiButton
        className={className}
        variant={variant}
        as={"button"}
        disabled={true}
        onClick={undefined}
        size={size}
      >
        {children}
      </SwarovskiButton>
    );
  }
}
